import classNames from 'classnames';
import React, {FC, memo} from 'react';
import style from './style.module.scss';
import {TIconName} from 'components/Icon/iconNames';
import {ICONS_CONFIG} from 'components/Icon/iconsConfig';
import {SPRITE_VERSION} from 'components/Icon/version';

interface IIconProps {
    icon?: TIconName;
    className?: string;
    isAutoSize?: boolean;
    height?: number | string;
    width?: number | string;
}

const Icon: FC<IIconProps> = memo(({className = '', icon, width = 24, height = 24, isAutoSize = false}) => {
    if (!icon) {
        return null;
    }

    return (
        <svg
            className={classNames(
                style.svgIcon,
                {
                    [style.autoSize]: isAutoSize,
                },
                className,
            )}
            height={height}
            width={width}
            viewBox={ICONS_CONFIG[icon]?.viewBox ?? `0 0 ${width} ${height}`}
        >
            <use xlinkHref={`/sprites/icons.${SPRITE_VERSION}.svg#${icon}`} />
        </svg>
    );
});

export default Icon;
